import { Drawer, DrawerTitle } from '@rocketlane/ui';
import { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { AddWebsite, AddWebsitePayload } from './add-website';

interface Props {
  open: boolean;
  apiDocVersion: boolean;
  folderName: string;
  onClose: () => void;
  onDone: (payload: AddWebsitePayload) => Promise<void>;
}
export const AddWebsiteDrawer: FC<Props> = ({
  open,
  apiDocVersion,
  onClose,
  onDone,
  folderName,
}) => {
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: folderName,
        link: '',
      },
    ];
  }, [folderName]);

  return (
    <Drawer size="672px" placement="right" open={open} onClose={onClose}>
      <DrawerTitle className="sr-only">
        <FormattedMessage
          id={
            apiDocVersion
              ? 'knowledge_base.add_api_doc.title'
              : 'knowledge_base.add_website.title'
          }
        />
      </DrawerTitle>
      <AddWebsite
        apiDocVersion={apiDocVersion}
        onClose={onClose}
        onDone={onDone}
        breadcrumbs={breadcrumbs}
      />
    </Drawer>
  );
};
